export default {
  error_data: {},
  error_code: -1,

  projectGroup: [],
  projectWorkType: [],
  projectList: [],
  projectListInfo: {},
  projectInfo: {},
  orderList: [],
  orderListInfo: {},
  nowOrder: {},
  hseStdwSectorList: [],
  hseStdwMidClassList: [],
  hseStdwUnitClassList: [],
  hseStdwUnitTaskList: [],
  hseStdWorkList: [],
  hseRentWorkList: [],
  hseProjectRentWorkList: [],
  hseInfoWorkPositionList: [],

  projectUserInfo: {},
  projectUserList: [],
  projectCompanyUserInfo: {},
  projectCompanyUserList: [],

  qrHistoryList: [],
  qrHistoryScannerList: [],

  fieldListInfo: {},
  fieldInfo: {},
  fieldUsers: {},
  fieldCompany: {},
  fieldFacilityCategoryOptionsInfo: {},
  fieldFacilityCategoryList: [],
  fieldFacilityCategoryOptions: []
}
